// extracted by mini-css-extract-plugin
export default {"r_l":"_3e654c7c74 _4087eadf09","t":"_54acdf655d"};